<template>
  <div id="doc-runtime-frame">
    <div id="app">
      <div id="content">
        <div class="header">
          <div class="left-buttons">
            <button @click="handleButton1" class="menu"></button>
          </div>
          <div class="right-controls">
            <div class="pagination">
              <button
                class="page-btn arrow-left"
                @click="prevPage"
                :disabled="currentPage === 1"
                :class="{'disabled': currentPage === 1}"
              >
              </button>
              <button
                class="page-btn arrow-right"
                @click="nextPage"
                :disabled="currentPage === totalPages"
                :class="{'disabled': currentPage === totalPages}"
              >
              </button>
            </div>
            <button class="close-btn" @click="closeWindow">終了</button>
          </div>
        </div>

        <div class="contents_frame">
          <div v-if="isVideoLoaded" class="iframe-header">
            <h1>{{ charpterName }}</h1>
          </div>
          <iframe v-if="isVideoLoaded" :key="'video-' + scoIdValue" scrolling="no" id="iframe" src="about:blank" class="content-wrapper"></iframe>
          <iframe v-if="!isVideoLoaded" :src="currentUrl" class="content-wrapper"></iframe>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" role="dialog" aria-hidden="true" v-show="menuNoticeBack"></div>
    <div class="menu-modal-dialog" v-show="menuElgMovNotice">
      <div style="text-align: right;">
        <button @click="menuElgMovNotice=!menuElgMovNotice;menuNoticeBack=!menuNoticeBack" class="menuBackBtn"></button>
        <div style="height: 1px; background-color: #e0e0e0;"></div>
      </div>
      <div class="top-text">
        {{ topText }}
      </div>
      <div class="menu-container">
        <button
          v-for="(item, index) in menuItems"
          :key="index"
          class="menu-item"
          :class="{ active: currentIndex === index }"
          @click="currentIndex = index"
        >
          {{ item.title }}
        </button>
      </div>

      <div class="content">
        <div v-if="currentIndex === 0">
          <div class="tree">
            <div v-for="(item, index) in flattenedData" :key="item.id"
                 :class="['node', 'level-' + item.level, { 'node-current': item.scoId === scoIdValue }]"
                 v-show="isVisible(item)"
                 @click="!hasChildren(item)"
                 @click.stop="hasChildren(item) && toggleNode(item)"
                 :style="{ cursor: !hasChildren(item) ? 'pointer' : 'default' }">
              <div
                class="arrow-up"
                :class="{ 'expanded': item.expanded }"
                v-show="hasChildren(item)"
              ></div>
              <div style="flex:3;display:flex;" @click="!hasChildren(item) && showLinkUrl(item)"
                   :style="!hasChildren(item) ? 'padding-left: 10px' : ''">
                <div class="node-row1">
                  <div class="node-left" :style="hasChildren(item) ? 'padding-bottom: 10px;' : ''">
                    <div class="node-text">{{ item.text }}</div>
                  </div>
                  <div v-if="!hasChildren(item)">
                    <div class="node-row2">
                      <div class="row2-div">最終受講日時</div>
                      <div class="row2-div">{{ item.dataTime }}</div>
                    </div>
                  </div>
                </div>
                <div class="node-right">
                  <div class="fixed-div" :style="getStatusStyle(item.status)">{{ item.status }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="currentIndex === 1">
          <div style="padding-top: 10px;"></div>
          <div
            style="display: flex;font-weight: 400;font-size: 16px; height: calc(100vh - 230px); overflow-y: auto;line-height: 24px;text-align: left" v-dompurify-html="courseDescription">
          </div>
        </div>

        <div v-if="currentIndex === 2">
          <div style="padding-top: 10px;"></div>
          <div
            style="display: flex;font-weight: 400;font-size: 16px; height: calc(100vh - 270px); overflow-y: auto;line-height: 24px;white-space: pre-line;text-align: left">
            {{ coursePrompt }}
          </div>
        </div>

      </div>
    </div>
    <BOverlay :show="isShowAlert" z-index=1031 no-wrap fixed opacity=0>
      <template #overlay>
        <BCard no-body class="alertCard1">
          <div class="text" v-dompurify-html="alertTitle"></div>
          <div class="button-inline1">
            <BButton class="cardButton1" @click="openLastModel()">はい</BButton>
            <BButton class="cardButton2" @click="closeLastModel()">キャンセル</BButton>
          </div>
        </BCard>
      </template>
    </BOverlay>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, inject, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { initPopElgSco, regularUpdatePopSco } from '@/apis/lessonContent'

export default {
  name: 'lessonContent',
  setup () {
    const router = useRouter()
    const currentPage = ref(1)
    const totalPages = ref(1)
    const service = inject('service')
    const isVideoLoaded = ref(false)
    const charpterName = ref('')
    const menuNoticeBack = ref(false)
    const menuElgMovNotice = ref(false)
    const topText = ref('')
    const currentIndex = ref(0)
    const courseDescription = ref('')
    const currentUrl = ref('')
    const scoIdList = ref([])
    const scoIdValue = ref('')
    const isShowAlert = ref(false)
    const lastStudyScoId = ref('')
    const alertTitle = ref('')
    let onBeforeUnLoadEvent = false
    const coursePrompt = ref('受講進捗を正しく反映させるため、\n' +
      '必ず「終了」ボタンをクリックして画面を閉じてください。')
    const flattenedData = ref([])
    const menuItems = computed(() => [
      { title: '目次' },
      { title: 'コース紹介' },
      { title: '受講上の注意' }
    ])
    const TRUSTED_ORIGIN = process.env.NODE_ENV === 'production' ? `${window.location.protocol}//${window.location.hostname}` : `${window.location.protocol}//${window.location.hostname}:8080`
    const param = ref({})

    const init = () => {
      try {
        if (!window.opener || !window.opener.sharedData) return
        param.value = window.opener.sharedData
      } catch (e) {
        return
      }

      if (!param.value || !param.value.elearningId) return

      service.lessonContent.init(param.value).then((res) => {
        const scomstList = Array.isArray(res?.scomstList) ? res.scomstList : []
        if (scomstList.length === 0) {
          alert('テーブルにデータがありません。')
          window.close()
          return
        }
        flattenedData.value = transformToFlattenedData(scomstList)
        courseDescription.value = res.elearningInf
        topText.value = res.elearningName
        scoIdList.value = Array.isArray(res?.scoIdList) ? res.scoIdList : []
        totalPages.value = res.scoIdList.length
        lastStudyScoId.value = res.scoId || ''
        alertTitle.value = '前回「' + res.charpterName + '」を最後に学習しました。この続きから始めますか？'
        if (lastStudyScoId.value !== '') {
          isShowAlert.value = true
        } else {
          menuElgMovNotice.value = true
          menuNoticeBack.value = true
        }

      }).catch((error) => {
        console.log(error)
      })
    }

    const handleMessage = (event) => {
      if (event.origin !== TRUSTED_ORIGIN) {
        return
      }
      let data
      try {
        data = JSON.parse(event.data)
      } catch (e) {
        console.error('メッセージ解析に失敗しました', e)
        return
      }
      if (data.type === 'SET_SCORE') {
        const {
          totalScore,
          passedScore
        } = data
        SetScoreToLMS(totalScore, passedScore)
      }
    }

    const handlePageHide = (event) => {
      if (!onBeforeUnLoadEvent && !event.persisted) {
        updateModel(scoIdValue.value)
      }
    }

    onMounted(() => {
      window.addEventListener('message', handleMessage)
      window.addEventListener('pagehide', handlePageHide)
      init()
    })

    onBeforeUnmount(() => {
      window.removeEventListener('message', handleMessage)
      window.removeEventListener('pagehide', handlePageHide)
    })

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--
        updateModel(scoIdValue.value)
        scoIdValue.value = scoIdList.value[currentPage.value - 1]
        checkLoginTime(scoIdValue.value)
      }
    }

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++
        updateModel(scoIdValue.value)
        scoIdValue.value = scoIdList.value[currentPage.value - 1]
        checkLoginTime(scoIdValue.value)
      }
    }

    window.SetScoreToLMS = function SetScoreToLMS (totalScore, passedScore) {
      let status
      if (totalScore >= passedScore) {
        status = 3
      } else {
        status = 4
      }
      let params = param.value
      const node = flattenedData.value.find(item => item.scoId === scoIdValue.value)
      params = {
        ...params,
        scoId: scoIdValue.value,
        completionStatus: status,
        totalScore: totalScore,
        videoIdFlag: node.linkType
      }
      service.lessonContent.updatePopSco(params)
    }

    const closeWindow = () => {
      onBeforeUnLoadEvent = true
      updateModel(scoIdValue.value)
      setTimeout(() => {
        window.close()
      }, 500)
    }
    const handleButton1 = () => {
      menuElgMovNotice.value = true
      menuNoticeBack.value = true
      // 現在の展開状態を保存
      const expandedMap = new Map()
      flattenedData.value.forEach(node => {
        if (node.scoId) {
          expandedMap.set(node.scoId, node.expanded)
        }
      })
      let params = param.value
      initPopElgSco(params).then(res=>{
        const scomstList = Array.isArray(res.data?.scomstList) ? res.data.scomstList : []
        if (scomstList.length === 0) {
          alert('テーブルにデータがありません。')
          window.close()
          return
        }
        flattenedData.value = transformToFlattenedData(scomstList)
        // 展開状態の復元
        flattenedData.value.forEach(node => {
          if (node.scoId && expandedMap.has(node.scoId)) {
            node.expanded = expandedMap.get(node.scoId)
          }
        })
        courseDescription.value = res.data.elearningInf
        topText.value = res.data.elearningName
        scoIdList.value = Array.isArray(res.data?.scoIdList) ? res.data.scoIdList : []
        totalPages.value = res.data.scoIdList.length
        lastStudyScoId.value = res.data.scoId || ''
      })
    }
    const hasChildren = (node) => {
      return node.childIds !== undefined && node.childIds.length > 0
    }
    const isVisible = (node) => {
      if (node.level === 1) return true
      if (node.parentId) {
        const parent = flattenedData.value.find(n => n.id === node.parentId)
        if (!parent || !parent.expanded) {
          return false
        }

        let currentParentId = parent.parentId
        while (currentParentId) {
          const ancestor = flattenedData.value.find(n => n.id === currentParentId)
          if (!ancestor || !ancestor.expanded) {
            return false
          }
          currentParentId = ancestor.parentId
        }
      }
      return true
    }
    const toggleNode = (node) => {
      node.expanded = !node.expanded
    }
    const showLinkUrl = (node) => {
      checkLoginTime(node.scoId)
      updateModel(scoIdValue.value)
    }

    function checkLoginTime (scoId) {
      service.lessonContent.check().then(res => {
        if (!res.check) {
          alert('利用時間外です。')
          window.close()
          return
        }
        initModel(scoId)
      })
    }

    function openLastModel () {
      checkLoginTime(lastStudyScoId.value)
      isShowAlert.value = false
    }

    function closeLastModel () {
      isShowAlert.value = false
      menuElgMovNotice.value = true
      menuNoticeBack.value = true
    }

    function initModel (scoId) {
      let params = param.value
      params = {
        ...params,
        scoId: scoId
      }
      scoIdValue.value = scoId
      service.lessonContent.initPopSco(params).then(res => {
        if (res.status === false) {
          alert('テーブルにデータがありません。')
          window.close()
          return
        }
        if (res.videoIdFlag === '0' || res.videoIdFlag === '3') {
          isVideoLoaded.value = true
          charpterName.value = res.charpterName
          nextTick(() => {
            const iframe = document.getElementById('iframe')
            if (iframe) {
              const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
              iframeDoc.open()
              iframeDoc.write(res.movPlatform)
              iframeDoc.close()
            }
          })
        } else {
          isVideoLoaded.value = false
          currentUrl.value = TRUSTED_ORIGIN + '/' + res.videoId + '?parentOrigin=' + window.location.origin
        }
        menuElgMovNotice.value = false
        menuNoticeBack.value = false
        currentPage.value = res.nowSco || 1
      })
    }

    const getStatusStyle = (status) => {
      if (status === '未学習') {
        return 'background-color:#DB5657;'
      } else if (status === '学習途中') {
        return 'background-color:#DAAC4C;'
      } else if (status === '修了') {
        return 'background-color:#85929A;'
      } else if (status === '合格') {
        return 'background-color:#8BC34A;'
      } else if (status === '不合格') {
        return 'background-color:#2196F3;'
      }
      return ''
    }

    function calculateLevel (item) {
      if (item.charpterId2 === 0) return 1
      if (item.charpterId3 === 0) return 2
      if (item.charpterId4 === 0) return 3
      if (item.charpterId5 === 0) return 4
      if (item.charpterId6 === 0) return 5
      return 6
    }

    function getStatus (completionStatus) {
      if (completionStatus === 0) return '未学習'
      if (completionStatus === 1) return '学習途中'
      if (completionStatus === 2) return '修了'
      if (completionStatus === 3) return '合格'
      if (completionStatus === 4) return '不合格'
      return '未学習'
    }

    function updateModel (scoId) {
      const normalizedScoId = String(scoId ?? '').trim()
      if (!normalizedScoId) return
      let params = param.value
      const node = flattenedData.value.find(item => item.scoId === normalizedScoId)
      params = {
        ...params,
        scoId: scoId,
        videoIdFlag: node.linkType
      }
      service.lessonContent.updatePopSco(params)
    }

    // タイミング送信要求
    setInterval(function () {
      if (scoIdValue.value !== '') {
        let params = param.value
        const node = flattenedData.value.find(item => item.scoId === scoIdValue.value)
        if (node.linkType === '2') {
          return
        }
        params = {
          ...params,
          scoId: scoIdValue.value,
          videoIdFlag: node.linkType,
          usrLoginLog: true
        }
        regularUpdatePopSco(params)
      }
    }, 60 * 1000)

    function transformToFlattenedData (originalData) {
      const flattened = []
      const nodeMap = new Map()
      let idCounter = 1

      originalData.forEach(item => {
        const level = calculateLevel(item)
        const id = idCounter++

        const node = {
          id: id,
          level: level,
          text: item.charpterName,
          expanded: false,
          childIds: [],
          parentId: null,
          dataTime: item.lstEntDtm || '',
          status: getStatus(item.completionStatus),
          scoId: item.scoId || '',
          originalItem: item,
          linkType: item.videoIdFlag || '',
        }

        const key = `${item.charpterId1}.${item.charpterId2}.${item.charpterId3}.${item.charpterId4}.${item.charpterId5}.${item.charpterId6}`
        nodeMap.set(key, node)
        flattened.push(node)
      })

      flattened.forEach(node => {
        const item = node.originalItem
        const ids = [item.charpterId1, item.charpterId2, item.charpterId3, item.charpterId4, item.charpterId5, item.charpterId6]

        for (let i = 5; i >= 0; i--) {
          if (ids[i] !== 0) {
            const parentIds = [...ids]
            parentIds[i] = 0
            for (let j = i + 1; j < 6; j++) {
              parentIds[j] = 0
            }
            const parentKey = parentIds.join('.')
            const parentNode = nodeMap.get(parentKey)
            if (parentNode && parentNode.id !== node.id) {
              node.parentId = parentNode.id
              parentNode.childIds.push(node.id)
              break
            }
          }
        }
        delete node.originalItem
      })

      return flattened
    }

    return {
      totalPages,
      currentPage,
      isVideoLoaded,
      charpterName,
      closeWindow,
      menuNoticeBack,
      menuElgMovNotice,
      topText,
      currentIndex,
      menuItems,
      handleButton1,
      courseDescription,
      coursePrompt,
      flattenedData,
      hasChildren,
      isVisible,
      toggleNode,
      showLinkUrl,
      getStatusStyle,
      currentUrl,
      scoIdList,
      scoIdValue,
      prevPage,
      nextPage,
      isShowAlert,
      alertTitle,
      lastStudyScoId,
      openLastModel,
      closeLastModel,
      SetScoreToLMS,
      TRUSTED_ORIGIN
    }
  }
}
</script>

<style scoped>
#doc-runtime-frame #app #content {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

#doc-runtime-frame {
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  padding: 0;
  color: #333333;
}

#doc-runtime-frame iframe {
  display: block;
  width: 100%;
  border: none;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  background-color: rgb(65, 65, 65, 0.7);
  overflow: hidden;
  outline: 0;
}

button:hover:not(:disabled) {
  background-color: #2294F7;
  color: #FFFFFF;
}

button[disabled] {
  background-color: #E8E8E8;
  color: #bbbbbb;
}

.menuBackBtn {
  background-image: url(../../assets/icon/close-gray030.svg);
  background-color: #fff;
  width: 40px;
  height: 40px;
}

.menuBackBtn:hover:not(:disabled) {
  background-image: url(../../assets/icon/close-gray030-hover.svg);
}

* {
  box-sizing: border-box;
  font-family: 'Meiryo';
  font-style: normal;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  left: 0;
  border-bottom: 1px solid #cccccc;
}

.menu {
  background-image: url(../../assets/icon/pop-menu.svg);
  background-repeat: no-repeat;
  display: inline-block;
  height: 40px;
  width: 40px;
  background-position: center;
  padding-right: 10px;
  background-size: contain;
}

.menu:hover:not(:disabled) {
  background-image: url(../../assets/icon/pop-menu-hover.svg);
}

.arrow-up.expanded {
  background-image: url(../../assets/icon/folder-open.png);
}

.contents_frame {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - 100px);
}

.content-wrapper {
  max-width: 1000px;
  overflow: scroll;
}

.left-buttons {
  display: flex;
  gap: 30px;
}

.right-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
}

button {
  padding: 5px 10px;
  border: none;
  background-color: #D5EBFF;
  color: #519CED;
  cursor: pointer;
}

.close-btn {
  width: 58px;
  height: 40px;
  font-weight: 400;
  font-size: 18px;
  background-color: #A8B0BB;
  color: #FFFFFF;
  background-size: contain;
}

.close-btn:hover:not(:disabled) {
  background-color: #868C99;
  color: #FFFFFF;
}

.page-btn {
  border: none;
  cursor: pointer;
  padding: 5px;
  width: 46px;
  height: 40px;
  background: #D5EBFF none;
  background-size: contain;
}

.page-btn:hover:not(:disabled) {
  background-color: #2294F7;
}

.arrow:hover:not(:disabled) {
  border-color: #FFFFFF;
}

.page-btn:hover:not(:disabled) .menuarrow {
  border-color: #FFFFFF;
}

.page-btn:disabled {
  color: #FFFFFF;
  cursor: not-allowed;
  background-color: #E8E8E8;

}

iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.arrow-left {
  background-image: url(../../assets/icon/arrow-left_50_2.svg);
}

.arrow-left:hover:not(:disabled) {
  background-image: url(../../assets/icon/arrow-left_50_3.svg);
}

.arrow-right {
  background-image: url(../../assets/icon/arrow-right_50_2.svg);
}

.arrow-right:hover:not(:disabled) {
  background-image: url(../../assets/icon/arrow-right_50_3.svg);
}

.page-btn:disabled .menuarrow {
  border-color: #fff;
}

.menu-modal-dialog {
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100vh);
  width: 100%;
  z-index: 1050;
  background-color: #fff;
  box-shadow: 5px 6px 9px 8px rgba(51, 51, 51, 0.2);
}

.menu-modal-dialog::-webkit-scrollbar-thumb {
  border: 2px solid #fff;
}

.top-text {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  width: calc(100% - 40px);
  padding: 0 0 0 10px;
  text-align: left;
  margin-top: 10px;
}

button {
  background-color: #D5EBFF;
}

.menu-container {
  display: flex;
  margin: 10px 0 20px;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.menu-item {
  box-sizing: border-box;
  cursor: pointer;
  background-color: #FFFFFF;
  border: 1px solid #2294F4;
  border-radius: 5px;
  margin: 0;
  width: 180px;
  height: 35px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}

.menu-item.active {
  box-sizing: border-box;
  background: #2294F4;
  border: 1px solid #2294F4;
  border-radius: 5px;
  width: 180px;
  height: 35px;
  color: #FFFFFF;
}

.content {
  margin: 0 auto;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
}

.tree {
  height: calc(100vh - 200px);
  overflow-y: auto;
}

.node {
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  min-height: 60px;
}

.node:hover {
  background: #EEF1F3;
}

.node-current {
  background: #EEF1F3;
}

.node + .node {
  border-top: none;
}

.node-row1 {
  flex: 1;
  padding-left: 12px;
}

.node-row2 {
  display: flex;
  padding: 5px 0;
}

.node-left {
  display: flex;
  flex: 1;
  align-items: center;
  padding: 10px 0 0 0;
  overflow: hidden;
}

.node-text {
  word-break: break-all;
  font-family: 'Meiryo';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
}

.node-right {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 10px;
  justify-content: flex-end;
  width: 80px;
}

.fixed-div {
  padding: 3px 0;
  font-weight: 700;
  font-size: 13px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 10px;
  border-radius: 3px;
  color: #FFFFFF;
}

.row2-div {
  margin-right: 20px;
  font-family: 'Meiryo';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
}

.arrow {
  width: 0;
  height: 0;
  border: 6px solid transparent;
  cursor: pointer;
  transition: transform 0.3s;
}

.arrow-up {
  background-image: url(../../assets/icon/folder-close.png);
  background-repeat: no-repeat;
  display: inline-block;
  height: 12px;
  width: 15px;
  background-position: center;
  padding-right: 10px;
}

.arrow-left.disabled {
  background-image: url(../../assets/icon/arrow-left_50_1.svg);
}

.arrow-left {
  background-image: url(../../assets/icon/arrow-left_50_2.svg);
}

.arrow-left:hover:not(:disabled) {
  background-image: url(../../assets/icon/arrow-left_50_3.svg);
}

.arrow-right.disabled {
  background-image: url(../../assets/icon/arrow-right_50_1.svg);
}

.level-1 {
  padding-left: 10px;
}

.level-2 {
  padding-left: 20px;
}

.level-3 {
  padding-left: 30px;
}

.level-4 {
  padding-left: 40px;
}

.level-5 {
  padding-left: 50px;
}

.level-6 {
  padding-left: 60px;
}

.status-header {
  font-family: 'Meiryo';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  padding: 20px 20px 0;
  color: #333333;
}

.status-list {
  box-sizing: border-box;
  padding-left: 40px;
  padding-right: 25px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 165px;
  background: #FFFFFF;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.status-item {
  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-bottom: 1px solid #E7E7E7;
  height: 33px;
  background: #FFFFFF;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.status-item-cell-1 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 10px;
  height: 33px;
  background: #FFFFFF;
  border-bottom: 1px solid #E7E7E7;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  width: 196px;
}

.status-item-cell-2 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  height: 33px;
  border-bottom: 1px solid #E7E7E7;
  background: #FFFFFF;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

#iframe {
  margin: 0 auto;
  padding-left: 8px;
  padding-right: 15px;
  height: 40%;
  overflow: hidden;
}

.iframe-header {
  padding-top: 20px;
  padding-bottom: 5px;
}

.iframe-header h1 {
  text-align: left;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  padding: 0 0 0 15px;
  margin: 0 15px 0 0;
}

.b-overlay {
  background: rgba(0, 0, 0, 0.6);

  .alertCard1 {
    align-items: center;
    padding: 16px;
    gap: 16px;
    width: 280px;
    background: #FFFFFF;
    border-radius: 5px;
    flex: none;
    order: 0;
    flex-grow: 1;
  }

  img, svg {
    width: 32px;
    height: 32px;
    padding: 1px;
  }

  .text {
    font-family: 'Meiryo';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    align-items: center;
    letter-spacing: -0.01em;
    text-align: left;
    color: #333333;
  }

  .button-inline1 {
    display: flex;

    .cardButton1 {
      width: 100px;
      height: 35px;
      margin-right: 15px;
      background-color: #D9D9D9;
      font-size: 14px;
      font-weight: 700;
      color: #333333;
      line-height: 19px;
      letter-spacing: 0;
      text-align: center;
      border-radius: 5px;
      border-color: #D9D9D9;
    }

    .cardButton2 {
      width: 100px;
      height: 35px;
      background-color: #FFFFFF;
      font-size: 14px;
      font-weight: 700;
      color: #333333;
      line-height: 19px;
      letter-spacing: 0;
      text-align: center;
      border-radius: 5px;
      border: 1px solid #333333;
    }

  }
}

.button-inline1 {
  display: flex;

  .cardButton1 {
    width: 97px;
    height: 34px;
    margin-right: 8px;
    background-color: #A8B0BB;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: center;
    border-radius: 4px;
    border-color: #A8B0BB;
  }

  .cardButton2 {
    width: 163px;
    height: 34px;
    background-color: #2394F7;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: center;
    border-radius: 4px;
    border-color: #2394F7;
  }

}
</style>
